<ng-container [ngSwitch]="type">
  <span *ngSwitchCase="'Purchase'" i18n="@@common.detail.purchase">Purchase order</span>
  <span *ngSwitchCase="'Forecast'" i18n="@@common.detail.forecast">Forecast order</span>
  <span *ngSwitchCase="'RFQ'" i18n="@@common.detail.rfq">RFQ order</span>
  <span *ngSwitchDefault i18n="@@common.order">Order</span>
</ng-container>
